export const REDUCER_NAME = "fbCreativeSlice";

// ==========================
// Create Creative DTO
// ==========================

export interface IFacebookCreativeCreateDTO {
  image: string; // uploaded image URL or image_hash
  name: string;
  message: string;
  link: string;
  type: "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "CONTACT_US" | "BOOK_NOW";
  valuelink: string;
}

// ==========================
// Creative Response DTO
// ==========================

export interface IFacebookCreativeDTO {
  id: string;
  image?: string;
  name?: string;
  message?: string;
  link?: string;
  type?: string;
  valuelink?: string;
  created_time?: string;
}

// ==========================
// Creative Redux State
// ==========================

export interface IFacebookCreativeState {
  facebookCreativeList: IFacebookCreativeDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
